import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { OverviewCard } from 'components/dashboard/components/overview-card';
import ReviewTable from 'components/dashboard/components/review-table';
import {
  FlexRow,
  Container,
  PlainButton,
  HeaderFlexRow,
  HeadingTitle,
} from 'components/styled-components';
import {
  StatContainer,
  BlueSection,
  DashboardContent,
} from 'components/dashboard/components/styled-components';
import * as actions from 'actions/vendor-request';
import colors from 'utils/colors';
import { getDashboardHeaders, getDashboardFields } from 'utils/functions';
import { H2Dashboard } from './components/styled-components';

const DashboardOverview = ({ awaitingCompletion, historical }) => (
  <StatContainer>
    <OverviewCard
      title="My ongoing assessments"
      icon="time"
      color={colors.icons.azure}
      flexBasis="100%"
      data={awaitingCompletion}
      filterType="requestStatus"
      filter="Awaiting Third Party Completion"
      owned={true}
    />
    <OverviewCard
      title="My historical assessments"
      icon="updated"
      color={colors.icons.amber}
      flexBasis="100%"
      data={historical}
      filterType="statusCategory"
      filter={['pass', 'review', 'fail']}
      owned={true}
    />
  </StatContainer>
);

class DashboardSponsorAdmin extends Component {
  componentDidMount() {
    this.props.fetchAllVendorRequests({ start: 0, limit: -1 });
  }

  render() {
    const { historical, appUser } = this.props;
    let awaitingCompletion = this.props.awaitingCompletion;

    //Filtered owned pending requests on dashboard
    if (awaitingCompletion && appUser) {
      awaitingCompletion.result = awaitingCompletion.result
        ? awaitingCompletion.result.filter(item => {
            return !(
              item.statusCategory === 'Pending' &&
              item.sponsorInformation.userID !== appUser.userID
            );
          })
        : awaitingCompletion.result;
      awaitingCompletion.totalCount = awaitingCompletion.result
        ? awaitingCompletion.result.length
        : awaitingCompletion.totalCount;
    }

    let personalHistorical = [];
    //filter personal historic assessments
    if (historical && appUser) {
      personalHistorical = historical.result
        ? historical.result.filter(item => item.sponsorInformation.userID === appUser.userID)
        : historical.result;
    }
    return (
      <Container>
        <HeaderFlexRow>
          <HeadingTitle>Dashboard</HeadingTitle>
          <NavLink to="/new">
            <PlainButton>Create Assessment</PlainButton>
          </NavLink>
        </HeaderFlexRow>
        <BlueSection>
          <H2Dashboard>Assessments Overview</H2Dashboard>
          <DashboardOverview
            awaitingCompletion={awaitingCompletion['totalCount']}
            historical={personalHistorical ? personalHistorical.length : 0}
          />
          <H2Dashboard>Recent Assessments</H2Dashboard>
        </BlueSection>

        <DashboardContent>
          <FlexRow flexWrap="wrap">
            <ReviewTable
              title="My Ongoing Assessments"
              data={awaitingCompletion}
              headers={getDashboardHeaders}
              fields={getDashboardFields}
              icon="time"
              color={colors.icons.azure}
              filterType="requestStatus"
              filter="Awaiting Third Party Completion"
              appUser={appUser}
              owned={true}
            />
            <ReviewTable
              title="All Historical Assessments"
              data={historical}
              headers={getDashboardHeaders}
              fields={getDashboardFields}
              icon="updated"
              color={colors.icons.amber}
              filterType="statusCategory"
              filter={['pass', 'review', 'fail']}
              appUser={appUser}
            />
          </FlexRow>
        </DashboardContent>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  awaitingCompletion: state.vendorRequest.allRequestsInProgress,
  historical: state.vendorRequest.allRequestsNotInProgress,
});

DashboardSponsorAdmin = connect(
  mapStateToProps,
  actions
)(DashboardSponsorAdmin);

export default DashboardSponsorAdmin;
